export default "__VITE_ASSET__3KmhHOT___"